import { Claim } from "../../api/ClientFileApi";

/** A selected claim as a bulk action's overlay lists it; `skipReason` is null when it will be written. */
export interface SelectedClaimRow {
  claim: Claim;
  skipReason: string | null;
}

/** The rows of `rows` that will gain an entry. */
export function processableRowsOf<TRow extends SelectedClaimRow>(rows: TRow[]): TRow[] {
  return rows.filter((row) => row.skipReason === null);
}

/** The claims of `rows` that will gain an entry. */
export function processableClaimIdsOf(rows: SelectedClaimRow[]): string[] {
  return processableRowsOf(rows).map((row) => row.claim.id);
}
